<template>
  <v-container fluid>
    <v-row>
      <v-col cols="4">
        <div class="title">
          <v-select
            v-model="project.id"
            text
            :items="projects"
            item-value="id"
            item-text="name"
            @change="handleProjectChange"
          />
        </div>
      </v-col>
      <v-col class="text-right">
        <v-menu
          v-model="createMenuToggle"
          dense
          @blur="createMenuToggle=false"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              style="margin-top:15px;"
              depressed
              v-on="on"
            >
              <v-icon
                small
                left
              >
                mdi-plus
              </v-icon>
              Create
            </v-btn>
          </template>
          <v-list
            class="pr-5"
            subheader
          >
            <v-subheader>Create New</v-subheader>
            <object-list-create-item
              v-for="a in $appConfig.objects"
              :key="a.type"
              :project="project"
              :action="a"
              @create="(e)=>{handleObjectCreated(a,e)}"
              @close="createMenuToggle=false"
            />
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <v-col />
    </v-row>
    <v-row>
      <v-col
        v-if="isInitiated && !hasObjects"
        cols="12"
      >
        <project-empty />
        <!-- <hmd-resources :resources="resources" /> -->
      </v-col>
      <v-col
        v-if="!isInitiated"
        cols="12"
      >
        <loading-objects-placeholder />
      </v-col>
    </v-row>
    <v-row v-if="hasObjects && isInitiated">
      <v-col
        v-for="action in $appConfig.objects"
        :key="action.type"
        cols="12"
        class="mb-0 pb-0 pt-0"
      >
        <template v-if="typeof project[action.plural] !== 'undefined' && project[action.plural].length > 0">
          <v-col
            cols="12"
            class="mb-0 pb-0"
          >
            {{ action.label }}
          </v-col>
          <v-col
            cols="12"
          >
            <v-row>
              <v-col
                cols="12"
                class="ma-0 pa-0"
              >
                <v-list
                  flat
                  subheader
                >
                  <v-list-item-group>
                    <v-divider />
                    <object-list-item
                      v-for="(d, index) in project[action.plural]"
                      :key="index"
                      :ref="'object-'+action.type+'-'+d.id"
                      :type="action.type"
                      :object="d"
                      :clonable="allowedToClone.includes(action.type)"
                      @update="getProject"
                      @delete="getProject"
                      @clone="cloneObject(action.type,d)"
                    />
                    <v-divider />
                  </v-list-item-group>
                </v-list>
              </v-col>
            </v-row>
          </v-col>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ObjectListItem from './../../../UIComponents/ObjectListItem'
  import ObjectListCreateItem from './../../../UIComponents/ObjectListCreateItem'

  import ProjectService from './services/ProjectService'
  import ProjectEmpty from './ProjectEmpty'
  import Resources from './Resources'
  import LoadingObjectsPlaceholder from './../../../UIComponents/Placeholders/LoadingObjectsPlaceholder'

  export default {
    components: {
      ObjectListCreateItem,
      ObjectListItem,
      'project-empty': ProjectEmpty,
      'hmd-resources': Resources,
      'loading-objects-placeholder': LoadingObjectsPlaceholder,
    },
    data () {
      return {
        createMenuToggle: false,
        isInitiated: false,
        allowedToClone: ['dataset', 'function', 'query'],
        resources: [
          { title: 'Connect you Data', desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.', url: 'test', flex: 4 },
          { title: 'Connect you Data 2', desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.', url: 'test', flex: 4 },
          { title: 'Connect you Data 3', desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.', url: 'test', flex: 4 },
        ],
        projects: ['Sales project', 'Test project', 'Hell project', 'Pingpong project'],
        action: '',
        project: {
          id: this.$route.params.project,
          dashboards: [],
          datasets: [],
          functions: [],
          integrations: [],
          triggers: [],
          apis: [],
        },
      }
    },
    computed: {
      hasObjects () {
        const found = _.find(this.$appConfig.objects, a => { return _.has(this.project, a.plural) ? this.project[a.plural].length > 0 : false })
        return !!found
      },
    },
    mounted () {
      this.getProjects()
      this.getProject()
    },
    methods: {
      cloneObject (type, object) {
        if (this.allowedToClone.includes(type)) { ProjectService.cloneObject(this, type, object) }
      },
      openObject (type, identifier) {
        if (this.$refs[`object-${type}-${identifier}`].length > 0) {
          this.$refs[`object-${type}-${identifier}`][0].$el.click()
        }
      },
      handleObjectCreated (action, object) {
        const self = this
        this.project[action.plural].push(object)
        _.delay(() => {
          const identifier = ('hmd_id' in object) ? object.hmd_id : object.id
          self.openObject(action.type, identifier)
        }, 300)
      },
      handleCreateObjectListTileClick (action) {
        if (action.CreateInDialog) {
          this.action = action.object
        } else {
          this.$router.push({ name: 'Create' + _.capitalize(action.object), params: { project: this.project.id } })
        }
      },
      handleProjectChange () {
        console.log(this.project)
        this.$router.push({ name: 'Project', params: { project: this.project.id } })
        this.getProject()
      },
      getProjects () {
        ProjectService.list(this).then(r => {
          this.projects = r.data.results
        })
      },
      getProject () {
        ProjectService.get(this, this.$route.params.project).then(r => {
          this.project = r.data
          this.isInitiated = true
        })
      },
    },
  }
</script>

<style>
    .project>.name .v-input__control>.v-input__slot:before,
    .project>.name .v-input__control>.v-input__slot:after {
        display: none !important;
    }

    .project>.name .v-select__selection--comma {
        font-size: 25px !important;
        font-weight: 300 !important;
    }

    .project>.name .v-select__selections input {
        display: none;
    }

    .project>.name .v-select__slot {
        width: auto;
        white-space: nowrap;
    }
        .created-at{
            font-size: 12px;
    font-weight: 300;

        }
        .title{
            font-size: 27px!important;
                text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-weight: 300;
    }
    .project a {
        text-decoration:none;
    }
</style>
